/**
 * custom-psb.js
 * for <psb-swiper> compatibility
 * Author: ChatGPT
 */

document.addEventListener("DOMContentLoaded", function () {
	console.log("custom-psb.js loaded");
	// すべてのSwiper SVGアイコンを削除
	document.querySelectorAll(".swiper-button-next svg, .swiper-button-prev svg").forEach((el) => el.remove());

	// Swiperが読み込まれていない場合は処理しない
	if (typeof Swiper === "undefined") {
		console.error("Swiper library not found. Please include Swiper JS before this script.");
		return;
	}

	// すべての <psb-swiper> タグを探す
	const psbSwipers = document.querySelectorAll("psb-swiper");
	if (!psbSwipers.length) {
		console.log("No <psb-swiper> elements found.");
		return;
	}

	psbSwipers.forEach((el, index) => {
		try {
			const configAttr = el.getAttribute("data-config");
			const config = configAttr ? JSON.parse(configAttr) : {};

			// Swiper本体のコンテナを探す
			const container = el.querySelector(".swiper-container, .swiper");
			if (!container) {
				console.warn(`⚠️ No .swiper-container found inside psb-swiper #${index}`);
				return;
			}

			// 一意なIDを割り当て（複数スライダー対応）
			const uniqueId = "psb-swiper-" + index;
			container.classList.add(uniqueId);

			// ナビゲーションの参照修正（必要に応じて）
			if (config.navigation) {
				const nextBtn = el.querySelector(config.navigation.nextEl);
				const prevBtn = el.querySelector(config.navigation.prevEl);
				if (!nextBtn || !prevBtn) {
					console.warn(` Navigation buttons not found in psb-swiper #${index}`);
				}
			}

			// Swiper初期化
			const swiperInstance = new Swiper(container, config);
			console.log(` Swiper initialized for psb-swiper #${index}`, swiperInstance);

			// 表示が "display:none" の場合、フェードインさせる
			const wrapperDiv = el.closest("[id^='psb-']");
			if (wrapperDiv && wrapperDiv.style.display === "none") {
				wrapperDiv.style.display = "block";
				wrapperDiv.style.opacity = "0";
				wrapperDiv.style.transition = "opacity 0.6s ease";
				setTimeout(() => (wrapperDiv.style.opacity = "1"), 100);
			}
		} catch (error) {
			console.error("Failed to initialize psb-swiper:", error);
		}
	});
});
